import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import store from '@/store'
import Top from '@/pages/search/top/index'
import Detail from '@/pages/search/detail/index'
import modalBtn from '@/pages/search/detail/pamphlet_modal_btn'
import AppHeader from '@/pages/components/app_header'
import AppFooter from '@/pages/components/app_footer'
import PricePlanModal from '@/pages/search/detail/price_plan_modal';
import * as VueGoogleMaps from "vue2-google-maps"

Vue.config.productionTip = false

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyDYIMCfBO8j0G8PCyzzKfP5jJO7yrk6wzk",
    libraries: "places",
    region: 'JP',
    language: 'ja',
  },
});

document.addEventListener('DOMContentLoaded', () => {
  axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';
  axios.defaults.headers['X-CSRF-TOKEN'] = document
    .getElementsByName('csrf-token')[0]
    .getAttribute('content');

  const el = document.getElementById('vueSearchMap');
  new Vue({
    el: el,
    render: h => h(Top),
    store: store,
  })

  const facility_detail = document.getElementById('vueFacilityDetail');
  new Vue({
    el: facility_detail,
    render: h => h(Detail),
    store: store,
  })

  const header = document.getElementById('appHeader');
  new Vue({
    el: header,
    render: h => h(AppHeader),
    store: store,
  })

  const footer = document.getElementById('appFooter');
  new Vue({
    el: footer,
    render: h => h(AppFooter),
    store: store,
  })

  const pamphletModalBtn = document.getElementById('pamphletModalBtn');
  new Vue({
    el: pamphletModalBtn,
    render: h => h(modalBtn),
    store: store,
  })

  const pricePlanModal = document.getElementById('pricePlanModal');
  new Vue({
    el: pricePlanModal,
    render: h => h(PricePlanModal),
    store: store,
  })

})
